import React from 'react';
import GaodeMap from './map';

export default (props) => {
    return (
        <div className="space-y-4">
            <GaodeMap />
        </div>
    );
};